import { Box, usePopoverContext } from "@chakra-ui/react";
import React from "react";
import zIndices from "theme/zIndices";

/**
 * Overlay that covers the entire screen when a popover is open.
 *
 * This is used to prevent the user from interacting with the rest of the page,
 * and to close the popover when clicking outside of it.
 */
export const PopoverOverlay: React.FC = () => {
  const { isOpen, onClose } = usePopoverContext();
  return (
    <Box
      onMouseDown={(e) => {
        e.stopPropagation();
        onClose();
      }}
      sx={{
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh",
        bg: "transparent",
        display: isOpen ? "block" : "none",
        // This assumes that the popover is displayed inside a portal
        zIndex: zIndices.popoverOverlay,
      }}
    />
  );
};
